import React, { useEffect, useState } from 'react';
import { Modal } from '../../ui/Modal';
import { Input } from '../../ui/Input';
import { Button } from '../../ui/Button';
import { parseAmount } from '../../../utils/currency';
import { OnDemandEnrollment } from '../../../types/trainingCourse';
interface EnrollmentFormModalProps {
  isOpen: boolean;
  // Undefined = new participant
  enrollment?: OnDemandEnrollment;
  defaultPrice?: number;
  onClose: () => void;
  onSave: (enrollment: OnDemandEnrollment) => void;
}
type Errors = Partial<Record<'firstName' | 'lastName' | 'email' | 'enrolledAt', string>>;
const today = () => new Date().toISOString().slice(0, 10);
export function EnrollmentFormModal({
  isOpen,
  enrollment,
  defaultPrice,
  onClose,
  onSave
}: EnrollmentFormModalProps) {
  const [form, setForm] = useState<OnDemandEnrollment>(() => blank(defaultPrice));
  const [errors, setErrors] = useState<Errors>({});
  useEffect(() => {
    if (!isOpen) return;
    setForm(enrollment ? {
      ...enrollment
    } : blank(defaultPrice));
    setErrors({});
  }, [isOpen, enrollment, defaultPrice]);
  const update = (changes: Partial<OnDemandEnrollment>) => {
    setForm(prev => ({
      ...prev,
      ...changes
    }));
    setErrors(prev => {
      const next = {
        ...prev
      };
      Object.keys(changes).forEach(k => delete next[k as keyof Errors]);
      return next;
    });
  };
  const handleSave = () => {
    const next: Errors = {};
    if (!form.firstName.trim()) next.firstName = 'Inserisci il nome';
    if (!form.lastName.trim()) next.lastName = 'Inserisci il cognome';
    if (!/^\S+@\S+\.\S+$/.test(form.email.trim())) next.email = "Inserisci un'email valida";
    if (!form.enrolledAt) next.enrolledAt = 'Inserisci la data di iscrizione';
    setErrors(next);
    if (Object.keys(next).length > 0) return;
    onSave({
      ...form,
      firstName: form.firstName.trim(),
      lastName: form.lastName.trim(),
      email: form.email.trim()
    });
  };
  return <Modal isOpen={isOpen} onClose={onClose} title={enrollment ? 'Modifica partecipante' : 'Aggiungi partecipante'} size="lg" data-id="element-1302" data-mp="1p1j65obn3ibt">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5" data-id="element-1303" data-mp="ueaxa3mvvk5w">
        <Input label="Nome" value={form.firstName} onChange={e => update({
        firstName: e.target.value
      })} error={errors.firstName} required data-id="element-1304" data-mp="uboh5flxfwc2" />
        <Input label="Cognome" value={form.lastName} onChange={e => update({
        lastName: e.target.value
      })} error={errors.lastName} required data-id="element-1305" data-mp="149vwju0ki6by" />
        <div className="sm:col-span-2" data-id="element-1306" data-mp="1d6my2lxw2ddx">
          <Input label="Email personale" type="email" value={form.email} onChange={e => update({
          email: e.target.value
        })} error={errors.email} required data-id="element-1307" data-mp="1s1t4ha0wce7s" />
        </div>
        <Input label="Iscrizione (data di acquisto)" type="date" value={form.enrolledAt} onChange={e => update({
        enrolledAt: e.target.value
      })} error={errors.enrolledAt} required data-id="element-1308" data-mp="3tv0jsjgievto" />
        <Input label="Importo di acquisto (senza IVA)" type="number" min={0} step="0.01" value={form.price ?? ''} onChange={e => update({
        price: parseAmount(e.target.value)
      })} endContent={<span className="text-xs" data-id="element-1310" data-mp="1zipnc1pkwu86">€</span>} data-id="element-1309" data-mp="29b56h2cm3oun" />
        {enrollment && <label className="sm:col-span-2 flex items-center gap-2 cursor-pointer w-fit" data-id="element-1311" data-mp="1ljzpgjuxqqir">
            <input type="checkbox" className="rounded border-slate-300 text-seform-orange focus:ring-seform-orange" checked={form.completed} onChange={e => update({
          completed: e.target.checked
        })} data-id="element-1312" data-mp="1pofvqm8gnzyi" />
            <span className="text-sm text-slate-700" data-id="element-1313" data-mp="360uwfua1rihk">Corso completato</span>
          </label>}
      </div>
      <div className="flex justify-end gap-3 mt-8 pt-5 border-t border-slate-100" data-id="element-1314" data-mp="3az67u9fzq11w">
        <Button variant="flat" color="secondary" onClick={onClose} data-id="element-1315" data-mp="1ay7zaez12u6w">
          Annulla
        </Button>
        <Button onClick={handleSave} data-id="element-1316" data-mp="15yn1i7vlgrvr">
          {enrollment ? 'Salva modifiche' : 'Aggiungi partecipante'}
        </Button>
      </div>
    </Modal>;
}
function blank(price?: number): OnDemandEnrollment {
  return {
    id: `enr-${Date.now()}`,
    firstName: '',
    lastName: '',
    email: '',
    enrolledAt: today(),
    price,
    completed: false
  };
}